import {
  createAllComponentSchemas,
  createAllComponentSchemasNarrowed
} from "./chunk-TZIAYNLI.js";

// src/schemas/components.ts
import { Type } from "@sinclair/typebox";
var StandardComponentDefinitionSchema = Type.Union(
  // Use Type.Any() for non-recursive standard components
  // Convert readonly array to mutable array for Type.Union
  [...createAllComponentSchemas(Type.Any())],
  {
    discriminator: { propertyName: "name" },
    description: "Standard component definition with discriminated union"
  }
);
var ComponentDefinitionSchema = Type.Recursive((This) => {
  const { roots, flow } = createAllComponentSchemasNarrowed(This);
  return Type.Union([...roots, flow], {
    discriminator: { propertyName: "name" },
    description: "Component definition with discriminated union"
  });
});

export {
  StandardComponentDefinitionSchema,
  ComponentDefinitionSchema
};
//# sourceMappingURL=chunk-5XH5YJJD.js.map